import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpRequest } from '@angular/common/http';
import {
	LOCALE_ID,
	ModuleWithProviders,
	NgModule,
	Optional,
	SkipSelf
} from '@angular/core';
import { AppConfig } from '@app/app.config';
import { UploadsService } from '@app/pages/dashboard/pages/uploads/services/uploads.service';
import { FileDownloadService } from '@app/shared/file-download/file-download.service';
import { IT } from '@assets/i18n/IT';
import { ApiClientModule } from '@eng-ds/api-client';
import { LoggerModule } from '@eng-ds/logger';
import { TranslateModule } from '@eng-ds/translate';
import { NbAuthModule } from '@nebular/auth';
import { NbDateFnsDateService } from '@nebular/date-fns';
import { NbRoleProvider, NbSecurityModule } from '@nebular/security';
import {
	acl,
	AuthenticationGuard,
	authenticationOptions,
	AuthInterceptor,
	AuthorizationGuard,
	NotAuthenticationGuard,
	RoleProvider,
	UserService
} from './auth';
import { ChangePasswordGuard } from './auth/guards/change-password-guard.service';
import { AuthService } from './auth/services/auth.service';
import { PasswordAuthStrategy } from './auth/strategy';
import { ErrorInterceptor, LoggerInterceptor } from './backend';
import { throwIfAlreadyLoaded } from './module-import-guard';
import {
	AUTH_INTERCEPTOR_HEADER,
	NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
	notInterceptedApiEndpoint
} from './tokens';
import { PageTitleService } from './utils';
import { UtilityService } from './utils/utility.service';

const filterInterceptorRequest = (req: HttpRequest<any>) => {
	if (req.url === AppConfig.authentication.loginUrl) {
		return true;
	} else {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const [_, apiEndopoint] = req.url.split(AppConfig.backend.baseUrl);
		console.log('AppConfig.backend.baseUrl', AppConfig.backend.baseUrl)
		console.log('req.url', req.url)
		console.log('req.url.split(AppConfig.backend.baseUrl)', req.url.split(AppConfig.backend.baseUrl))
		console.log('-', _)
		console.log('apiEndopoint', apiEndopoint)
		console.log('notInterceptedApiEndpoint', notInterceptedApiEndpoint)
		return notInterceptedApiEndpoint.includes(apiEndopoint);
	}
};

export const CORE_PROVIDERS = [
	NbSecurityModule.forRoot(acl).providers,
	{
		provide: NbRoleProvider,
		useClass: RoleProvider
	},
	// AnalyticsService,
	// SeoService,
	PasswordAuthStrategy,
	PageTitleService,
	UserService,
	UtilityService,
	UploadsService,
	ChangePasswordGuard,
	FileDownloadService,
	NbDateFnsDateService,
	AuthenticationGuard,
	AuthorizationGuard,
	NotAuthenticationGuard,
	{
		provide: NB_AUTH_TOKEN_INTERCEPTOR_FILTER,
		useValue: filterInterceptorRequest
	},
	{ provide: AUTH_INTERCEPTOR_HEADER, useValue: 'Authorization' },
	{
		provide: HTTP_INTERCEPTORS,
		useClass: AuthInterceptor,
		multi: true
	},
	{
		provide: HTTP_INTERCEPTORS,
		useClass: LoggerInterceptor,
		multi: true
	},
	{
		provide: HTTP_INTERCEPTORS,
		useClass: ErrorInterceptor,
		multi: true
	},
	{ provide: LOCALE_ID, useValue: 'it' }
];

@NgModule({
	imports: [CommonModule, LoggerModule, ApiClientModule, TranslateModule],
	exports: [NbAuthModule],
	declarations: []
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		throwIfAlreadyLoaded(parentModule, 'CoreModule');
	}

	static forRoot(
		appConfig: typeof AppConfig
	): ModuleWithProviders<CoreModule> {
		return {
			ngModule: CoreModule,
			providers: [
				...CORE_PROVIDERS,
				...NbAuthModule.forRoot(authenticationOptions(appConfig))
					.providers,
				...LoggerModule.forRoot(appConfig.logger).providers,
				...ApiClientModule.forRoot({
					backend: appConfig.backend
				}).providers,
				AuthService,
				...TranslateModule.forRoot({
					langs: [
						{
							code: 'it',
							isDefault: true,
							label: 'Italiano',
							translations: IT
						}
					]
				}).providers
			]
		};
	}
}
